import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  NgZone,
  inject,
  output
} from '@angular/core';
import { Carousel, CarouselStyle } from 'primeng/carousel';
import { PrimeTemplate } from 'primeng/api';
import { MTypePillComponent } from '../../../components/m-type-pill/m-type-pill.component';
import { MCardComponent } from '../../../components/m-card/m-card.component';
import { MChartBarComponent } from '../../../components/m-chart-bar/m-chart-bar.component';
import { MButtonComponent } from '../../../components/m-button/m-button.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'm-benchmarks-carousel',
  templateUrl: './m-benchmarks-carousel.component.html',
  styleUrls: ['./m-benchmarks-carousel.component.scss'],
  providers: [CarouselStyle],
  imports: [
    Carousel,
    PrimeTemplate,
    MTypePillComponent,
    MCardComponent,
    MChartBarComponent,
    MButtonComponent
  ]
})
export class MCarouselComponent extends Carousel {
  constructor() {
    const el = inject(ElementRef);
    const zone = inject(NgZone);

    super(el, zone);
  }

  readonly navigateRequest = output<void>();

  onButtonClick(): void {
    this.navigateRequest.emit();
  }

  // PrimeNG 20 applies the root class on the host via `host: { '[class]': "cn(cx('root'), styleClass)" }`.
  // This wrapper extends Carousel but renders its OWN inner <p-carousel>, so that metadata is inherited
  // onto <m-benchmarks-carousel> too — duplicating the carousel root styling on the wrapper host.
  // Neutralize on the wrapper host; the inner carousel is unaffected.
  override cx(): string {
    return '';
  }
}
